import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DebuggingWindowComponent } from '@examdojo/core/debugging';
import { FeatureFlagDirective } from '@examdojo/core/feature-flag';
import { ExamDojoFeatureFlag } from '@examdojo/models/feature-flag';
import { IonApp } from '@ionic/angular/standalone';
import { register as registerSwiper } from 'swiper/element/bundle';
import { NavigateOnActiveSyllabusChangeService } from './shell/effects/navigate-on-active-syllabus-change.service';

registerSwiper();

const APP_EFFECTS = [NavigateOnActiveSyllabusChangeService];

@Component({
  selector: 'exam-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonApp, RouterOutlet, DebuggingWindowComponent, FeatureFlagDirective],
  providers: [...APP_EFFECTS],
})
export class AppComponent {
  constructor() {}

  readonly instantiatedServices = [...APP_EFFECTS].map((service) => inject(service));

  protected readonly ExamDojoFeatureFlag = ExamDojoFeatureFlag;
}
